module.exports = __webpack_public_path__ + "static/media/Quiz-Results02-1.e62debe.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/Quiz-Results02-1.mp3
// module id = 5n57
// module chunks = 1